






















import { Component, Prop, Vue } from 'vue-property-decorator';
import { AxiosResponse } from 'axios';
import storage from 'baimahu/storage';
@Component
export default class ConfigFirst extends Vue {
  is_loading: boolean = false;
  coupon_type: number = 1;
  form_item_layout: any = {
    labelCol: { span: 3 },
    wrapperCol: { span: 21 },
  };
  form_data: object = {};

  nextStep() {
    this.form_data = {
      coupon_type: this.coupon_type,
    };
    storage.setItem('coupon_first', JSON.stringify(this.form_data));
    this.$router.push('/promotion/coupon/config-second/0');
  }
}
